var _g, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlarmY(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_327_442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4489 3.5625C11.3399 3.5625 5.5625 9.33989 5.5625 16.4489C5.5625 23.5578 11.3399 29.3352 18.4489 29.3352C25.5578 29.3352 31.3352 23.5578 31.3352 16.4489C31.3352 9.33989 25.5578 3.5625 18.4489 3.5625Z",
    fill: "#FFD13E"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 18C17.9535 18 17.5 17.5015 17.5 16.8717V10.1283C17.5 9.51166 17.9419 9 18.5 9C19.0581 9 19.5 9.49854 19.5 10.1283V16.8717C19.5 17.4883 19.0581 18 18.5 18Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5682 23.6818C18.4635 23.6818 18.3589 23.6627 18.2542 23.6151C18.1591 23.577 18.064 23.5199 17.9878 23.4437C17.8356 23.2913 17.75 23.0818 17.75 22.8628C17.75 22.758 17.7785 22.6533 17.8166 22.5485C17.8547 22.4438 17.9117 22.3581 17.9878 22.2819C18.1876 22.0914 18.4635 22.0057 18.7299 22.0629C18.7775 22.0629 18.8251 22.0914 18.8726 22.1105C18.9202 22.1295 18.9678 22.1486 19.0153 22.1867C19.0629 22.2152 19.101 22.2533 19.1485 22.2819C19.2246 22.3676 19.2817 22.4438 19.3198 22.5485C19.3578 22.6438 19.3864 22.7485 19.3864 22.8628C19.3864 23.0818 19.3007 23.2913 19.1485 23.4437C19.0629 23.5199 18.9773 23.577 18.8821 23.6151C18.787 23.6627 18.6823 23.6818 18.5682 23.6818Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_327_442",
    x: 0.5625,
    y: 0.5625,
    width: 35.7729,
    height: 35.7727,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.819608 0 0 0 0 0.243137 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_327_442"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_327_442",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarmY);
export default __webpack_public_path__ + "static/media/alarmY.b8bc0bb1d3a4151d7c844e16f9e0cc72.svg";
export { ForwardRef as ReactComponent };